var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndex5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#index5_svg__clip0_247_28402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8a8 8 0 018-8h16v16a8 8 0 01-8 8H0V8z",
    fill: "#000",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.347 12.747V7.745h4.933v1.327h-3.682v2.095a2.331 2.331 0 011.479-.508c.355.008.681.072.977.19.28.131.506.292.68.482.258.254.444.549.558.883.06.182.102.404.127.666.026.267.038.595.038.984 0 .601-.042 1.062-.127 1.384a2.219 2.219 0 01-.444.844c-.182.242-.446.462-.793.66-.339.208-.741.316-1.207.324a2.89 2.89 0 01-1.72-.558c-.529-.381-.857-.997-.984-1.848h1.327c.144.711.586 1.071 1.327 1.08.317 0 .571-.064.761-.19a.968.968 0 00.381-.483c.076-.2.123-.415.14-.648.008-.228.013-.45.013-.666.008-.53-.074-.959-.248-1.289a.99.99 0 00-.412-.374 1.765 1.765 0 00-.68-.115c-.241 0-.461.055-.66.165-.199.115-.377.313-.533.597h-1.25z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "index5_svg__clip0_247_28402"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgIndex5;